import React, { useCallback } from 'react';

import { IInput } from '../../interfaces';

export default function Input(props: IInput) {
    const {
        value,
        accept,
        autoFocus,
        autocomplete,
        checked,
        className = '',
        error,
        id,
        min,
        name,
        onChange,
        onKeyDown,
        pattern,
        placeholder,
        required,
        type,
        validateInput,
    } = props;
    const onChangeWrapper = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            if (type === 'checkbox') {
                onChange && onChange(event.target.checked.toString());
            } else {
                onChange && onChange(event.target.value);
            }
        },
        [onChange, type]
    );
    const onKeyDownWrapper = useCallback(
        (event: React.KeyboardEvent) => {
            onKeyDown && onKeyDown(event.key);
        },
        [onKeyDown]
    );

    return (
        <React.Fragment>
            <input
                id={id ?? undefined}
                type={type}
                name={name}
                value={value}
                checked={checked}
                autoComplete={autocomplete}
                accept={accept}
                autoFocus={autoFocus ? autoFocus : false}
                className={
                    error ? `error input ${className}` : `input ${className}`
                }
                onChange={onChangeWrapper}
                onBlur={validateInput}
                required={required}
                placeholder={placeholder}
                pattern={pattern}
                min={min}
                onKeyDown={onKeyDownWrapper}
                disabled={props.disabled}                
            />
            <span
                className='inputError'
                style={{ display: error ? 'inline' : 'none' }}
            >
                {error}
            </span>
        </React.Fragment>
    );
}
